import axios from '../config/axiosConfig';
import ApiKey from './constant/ApiKey';
import { AIR_URL, ADMIN_URL } from './constant/BaseApiUrl';

export default class AirManagementService {
  getListAir() {
    return axios.get(`${AIR_URL}${ApiKey.AIR_PORTS}/list-for-management`);
  }

  getFareRequest(body) {
    return axios.post(`${AIR_URL}${ApiKey.FIND_FARE_REQUEST}`, body);
  }

  updateAirStatus(payload) {
    return axios.put(`${AIR_URL}${ApiKey.AIR_PORTS}/${payload.sk}/status/${payload.type}?status=${payload[payload.type]}`);
  }

  updateAirport(payload) {
    return axios.put(`${AIR_URL}${ApiKey.AIR_PORTS}`, payload);
  }

  deleteAirport(id) {
    return axios.delete(`${AIR_URL}${ApiKey.AIR_PORTS}/${id}`);
  }

  syncData() {
    return axios.get(`${AIR_URL}${ApiKey.SYNC_DATA}`);
  }

  getListFlight() {
    return axios.get(`${ADMIN_URL}${ApiKey.AIRLINE}/list-for-management`);
  }

  addFlight(payload) {
    return axios.post(`${ADMIN_URL}${ApiKey.AIRLINE}`, payload);
  }

  deleteFlight(sk) {
    return axios.delete(`${ADMIN_URL}${ApiKey.AIRLINE}/${sk}`);
  }

  getFlightById(sk) {
    return axios.get(`${ADMIN_URL}${ApiKey.AIRLINE}/${sk}`);
  }

  updateFlightStatus(sk, status) {
    return axios.put(`${ADMIN_URL}${ApiKey.AIRLINE}/${sk}/status?status=${status}`);
  }

  getFlightSeat(payload) {
    return axios.post(`${AIR_URL}${ApiKey.FLIGHT_SEAT_INFORMATION}`, payload);
  }

  getListTax() {
    return axios.get(`${ADMIN_URL}${ApiKey.AIRLINE_TAX_LIST}`);
  }

  addTax(payload) {
    return axios.post(`${ADMIN_URL}${ApiKey.AIRLINE_TAX}`, payload);
  }

  updateTax(payload) {
    return axios.put(`${ADMIN_URL}${ApiKey.AIRLINE_TAX}`, payload);
  }

  removeTax(id) {
    return axios.delete(`${ADMIN_URL}${ApiKey.AIRLINE_TAX}/${id}`);
  }

  getUrlUploadFileAir() {
    return `${AIR_URL}${ApiKey.AIR_PORT}/${ApiKey.PREVIEW_FILE}`;
  }

  importFileAir(payload) {
    return axios.post(`${AIR_URL}${ApiKey.AIR_PORT}/${ApiKey.IMPORT_FILE}`, payload);
  }

  getPreviewAirByFileName(fileName) {
    return axios.post(`${AIR_URL}${ApiKey.AIR_PORT}/${ApiKey.URL_FILE}/${ApiKey.PREVIEW_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }

  revertAirVersion(fileName) {
    return axios.post(`${AIR_URL}${ApiKey.AIR_PORT}/${ApiKey.REVERT_FILE}`, fileName, {
      headers: {
        'content-type': 'text/plain'
      }
    });
  }
}
